// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.markdown-edit-view .text-editor .switch-menu {
	z-index: 10;
}
.markdown-edit-view .text-editor .CodeMirror {
	height: 100% !important;
}
.markdown-edit-view .text-editor .ProseMirror-menubar-wrapper {
	height: 100% !important;
}
.markdown-edit-view .text-editor .ProseMirror {
	height: 100%;
	overflow: auto;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
